<div
  class="h-auto max-w-ultrawide w-full  rounded-lg mb-4 flex flex-wrap gap-2 justify-between items-center">
  <h1 class="text-primary font-bold text-xl">{{pageName}}</h1>
  <div class="flex gap-2">

    <div class="relative inline-block" #popupContainer>
      <button (click)="togglePopup()" class="relative">
        <img class="w-[60px] h-[60px]" alt="Notifications" src="assets/icons/notifications.svg">
        <span *ngIf="unreadCount > 0"
          class="absolute top-0 right-0 bg-error text-white text-xs rounded-full px-1.5 py-0.5">
          {{ unreadCount }}
        </span>
      </button>

      <app-notifications-popup *ngIf="showPopup" [notifications]="notifications" (markAsRead)="markAsRead($event)"
        [loadMore]="loadMoreCallback" [waitingForNextPageResponse]="waitingForNextPage">
      </app-notifications-popup>
    </div>


    <div class="w-[60px] h-[60px]">
      <app-custom-avatar [initials]="userInitials" [imageUrl]="getProfileImage"></app-custom-avatar>
    </div>
  </div>
</div>